module.exports = __webpack_public_path__ + "static/img/3.ef6184b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hezuo/3.png
// module id = Q+wL
// module chunks = 1